<template>
  <qx-card title="">
    <Order ref="byDate" width="100%" />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
          >
            <section slot-scope="scope">
              <!-- 报警次数 -->
              <section v-if="scope.column.property === 'alarmNum'">
                <span :class="scope.row.alarmNum>0 ?'primary cur':''" @click="toAlarmList(scope.row)">{{
                    scope.row[scope.column.property]
                  }}</span>
              </section>
              <section v-else>{{scope.row[scope.column.property] }}</section>
              </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import Order from './order';
import {getOilGasStatisticListByCarNo} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    vehicleType: {
      type: Number,
    },
  },
  components: {
    Order,
  },
  data () {
    return {
      chartObj: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'carNo', label: '车牌号'},
          {prop: 'linkman', label: '司机姓名'},
          {prop: 'mileageSumDouble', label: '里程（KM）'},
          {prop: 'driverTimeSumStr', label: '行驶时长'},
          {prop: 'fuelCostSumDouble', label: '总油耗（L）'},
          {prop: 'avgHundredFuelAvgDouble', label: '百公里平均油耗（L/100KM）'},
          {prop: 'idleTimeSumStr', label: '怠速时长'},
          {prop: 'alarmNum', label: '报警次数'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  watch: {
    vehicleType: {
      immediate: true,
      async handler (val) {
        if (val === 2) {
          this.tableData.title.forEach((item) => {
            if (item.label.includes('百公里平均油耗（L/100KM）')) {
              item.label = '百公里平均气耗（m³/100KM）';
            }
            if (item.label.includes('油耗')) {
              item.label = '总气耗（m³）';
            }
          });
        } else {
          this.tableData.title.forEach((item) => {
            if (item.label.includes('百公里平均气耗')) {
              item.label = '百公里平均油耗（L/100KM）';
            }
            if (item.label.includes('气耗')) {
              item.label = '总油耗（L）';
            }
          });
        }
      },
    },
  },
  methods: {
    getList: getOilGasStatisticListByCarNo,
    handleSubSucc (res) {
      this.getChartData(res);
    },

    async getChartData (data) {
      this.chartObj = data.option;
      if (this.chartObj) {
        this.chartObj.isShowCustomData = true;
        delete this.chartObj.toolbox;
      }

      this.$nextTick(() => {
        this.$refs.byDate.setOptions(this.chartObj);
      });
    },
    toAlarmList (row) {
      if (row.alarmNum === 0) {
        return;
      }
      let startTime = new Date(this.searchBoxData.startTime).getTime();
      let endTime = new Date(this.searchBoxData.endTime).getTime();
      let carNo = encodeURI(row.carNo);
      this.jump({
        label: '报警列表',
        url: `/manage/service/oilAndGasConsume/alarm?carNo=${carNo}&startTime=${startTime}&endTime=${endTime}`,
      });
    },
  },
};
</script>

<style scoped>

</style>
